import React from 'react'
import './Clouds.css'
export default function Clouds() {
  return (
    <div className="background-wrap">
      <div className="c1">
        <div className="cloud"></div>
      </div>
      <div className="c2">
        <div className="cloud"></div>
      </div>
      <div className="c3">
        <div className="cloud"></div>
      </div>
      <div className="c4">
        <div className="cloud"></div>
      </div>
      <div className="c5">
        <div className="cloud"></div>
      </div>
      <div className="c6">
        <div className="cloud"></div>
      </div>
    </div>
  )
}
